import { defineComponent } from "vue";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "dot-pagination",
  props: {
    pages: { default: void 0 },
    prefix: { default: "Seite" },
    ariaLabel: { default: "Pagination" }
  },
  emits: { update: (payload) => typeof payload === "number" },
  setup(__props) {
    function ariaLabelForPageNumber(pages, page) {
      if (page.number === 0) {
        return "Gehe zur ersten Seite";
      }
      if (page.number === pages.length - 1) {
        return "Gehe zur letzten Seite";
      }
      return `Gehe zu Seite ${page.number + 1}`;
    }
    return { __sfc: true, ariaLabelForPageNumber, LinkButton };
  }
});
export {
  _sfc_main as default
};
